import React from 'react'
import PropTypes from 'prop-types'
import { ProcessesStatisticsItems } from '../../organism'
import { MODULES } from '../../../config/constants'

const Statistics = ({ classes }) => (
  <div className={classes.root}>
    <ProcessesStatisticsItems module={MODULES.ID_EMPLOYEE_LINE} />
  </div>
)

Statistics.propTypes = {
  classes: PropTypes.object.isRequired
}

export default Statistics
